// 404.js
import React, { useState, useEffect } from "react";
import Link from "next/link";
import Head from "next/head";
import Header from "../components/common/header";
import Footer from "../components/common/footer";
import Image from 'next/image';
//Markdown-Parser
import ReactMarkdown from 'react-markdown';
// Custom NPM Package
import {
  BackToTopButton,
  CookieBanner,
} from "@benchvondaranch/npm.react-ui-library";
import variables from "../styles/variables.module.scss";
//Load Styles
import styles from "../styles/pages/Pricelist.module.scss";
//i18n
import { useTranslation } from "react-i18next";
// Using Global Redux State
import { useSelector, useDispatch } from "react-redux";
import { updateLocalStorage } from "../store/userSlice";
import {
  Container,
  Row,
  Col,
  Card,
  Placeholder,
  Button,
} from "react-bootstrap";
import { getReadableStringOfDate } from "../utils/generalHelper";

export default function Pricing() {
  const [isLoading, setIsLoading] = useState(true); //for test
  const { t, i18n } = useTranslation();
  const [data, setData] = useState({});
  const [showCookieBanner, setShowCookieBanner] = useState(true);
  const dispatch = useDispatch();

  const getData = async () => {
    try {
      const response = await fetch(
        `/api/backend/pricelist?locale=${i18n.language}`,
        {
          headers: {
            Accept: "application/json",
          },
        }
      );
      const dataFromBackend = await response.json();
      setData(dataFromBackend);
    } catch (error) {
      console.log("[Error - loading pricelist] - " + error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    async function fetchDataFromNextAPI() {
      getData();
    }
    fetchDataFromNextAPI();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Cookie Banner START
  // Check if the user already agreed to the GDPCR - Cookie Banner
  useEffect(() => {
    if (typeof window !== "undefined") {
      const cookieBannerDataFromLocalStorage = localStorage.getItem(
        "cookieBannerData"
      )
        ? JSON.parse(localStorage.getItem("cookieBannerData"))
        : undefined;

      if (cookieBannerDataFromLocalStorage?.accepted === "true") {
        setShowCookieBanner(false);
      } else {
        setShowCookieBanner(true);
      }
    }
  }, []);

  const selectAll = (e) => {
    const cookieData = {
      necessary: "true",
      marketing: "true",
      performance: "true",
      accepted: "true",
      acceptedDateTime: `${new Date()}`,
      savedViaButtonAction: `${e.target.getAttribute("data-c-action")}`,
    };
    localStorage.setItem("cookieBannerData", JSON.stringify(cookieData));
    dispatch(updateLocalStorage(cookieData));
    setShowCookieBanner(false);
  };
  const saveSelection = (e) => {
    // Get All Checkboxes of CookieBanner
    const cbNecessary = document.getElementById("necessary").checked;
    const cbMarketing = document.getElementById("marketing").checked;
    const cbPerformance = document.getElementById("performance").checked;
    const cookieData = {
      necessary: `${cbNecessary}`,
      marketing: `${cbMarketing}`,
      performance: `${cbPerformance}`,
      accepted: "true",
      acceptedDateTime: `${new Date()}`,
      savedViaButtonAction: `${e.target.getAttribute("data-c-action")}`,
    };
    localStorage.setItem("cookieBannerData", JSON.stringify(cookieData));
    dispatch(updateLocalStorage(cookieData));
    setShowCookieBanner(false);
  };
  // Cookie Banner END
  if (isLoading===true) return null;
  
  return (
    <>
      <Head>
        <title>{t("meta_tag_pricing_page_title")}</title>
        <link rel="icon" href="/favicon.ico" />
      </Head>

      <Header />
      <Container className="pt-0" fluid>
        <Row
          className="webpageTitle"
          style={{
            backgroundColor:
              variables.initial_standardHeaderBanner_backgroundColor,
            color: variables.initial_standardHeaderBanner_fontColor,
          }}
        >
         <Col></Col>
          <Col  xs={'auto'} sm={'auto'} md={'auto'}  lg={'auto'}  xl={'auto'}>
            <h2 className={`${styles['h2']}`}>{t("page_pricing_banner_h1")}</h2>
          </Col>
          <Col></Col>
        </Row>
      </Container>
      <section className="pregnancy">
            <Container fluid="sm" >                  
                      <Row xs="1" sm="1" md="2">                        
                            <Col  md="12">
                              <ReactMarkdown className={`${styles['general-md']}`}>{data.attributes.description}</ReactMarkdown>  
                            </Col>                    
                      </Row>                     
                  </Container>
                  <Container fluid="sm" className={`${styles['seperator']}`}>                  
                          <h1>Mutter-Kind Pass Beratung 18.-22. SSW</h1>
                  </Container>                  
                  <Container fluid="sm" >  
                    {
                      data.attributes.mother_child_talk.map((data, i) => {                      
                        return (
                          <div className={`${styles['pricelist-item']}`} key={i}>   
                          <Row xs="1" sm="1" md="1">
                            <Col xs="8" sm="10" md="10" >
                                <span className={`${styles['pricelist-item-title']}`}>{data.title}</span> 
                              </Col>
                              <Col xs="4" sm="2" md="2">
                              <span className={`${styles['pricelist-item-title']}`}>{data.is_free === true ? 'kostenlos' : data.price + '€'}</span> 
                            </Col>
                          </Row>
                          <Row xs="1" sm="1" md="1">
                          <Col xs="8" sm="10" md="10" >                              
                              <ReactMarkdown className={`${styles['pricelist-item-subtitle']}`}>{data.description}</ReactMarkdown> 
                            </Col>
                          </Row>
                          </div>
                              )})  
                    }
                </Container>  
                  <Container fluid="sm" className={`${styles['seperator']}`}>               
                          <h1>Wochenbettbetreuung</h1>
                  </Container>
                  <Container fluid="sm" >  
                    {
                      data.attributes.childbed.map((data, i) => {                      
                        return (
                          <div className={`${styles['pricelist-item']}`} key={i}>   
                          <Row xs="1" sm="1" md="1">
                              <Col xs="8" sm="10" md="10" >
                                <span className={`${styles['pricelist-item-title']}`}>{data.title}</span> 
                              </Col>
                              <Col xs="4" sm="2" md="2">
                              <span className={`${styles['pricelist-item-title']}`}>{data.price} €</span> 
                            </Col>
                          </Row>
                          <Row xs="1" sm="1" md="1">
                          <Col md="12">
                              <span className={`${styles['pricelist-item-subtitle']}`}>{data.subtitle}</span> 
                            </Col>
                          </Row>
                          </div>
                              )})  
                    }
                </Container>   
                <Container fluid="sm" className={`${styles['seperator']}`}>                  
                          <h1>Akupunktur und Moxen</h1>                          
                  </Container>
                  <Container fluid="sm" >  
                    {
                      data.attributes.acupuncture.map((data, i) => {                      
                        return (
                          <div className={`${styles['pricelist-item']}`} key={i}>   
                          <Row xs="1" sm="1" md="1">
                              <Col xs="8" sm="10" md="10" >
                                <span className={`${styles['pricelist-item-title']}`}>{data.title}</span> 
                              </Col>
                              <Col xs="4" sm="2" md="2">
                              <span className={`${styles['pricelist-item-title']}`}>{data.price} €</span> 
                            </Col>
                          </Row>
                          <Row xs="1" sm="1" md="1">
                            <Col md="12">
                              <span className={`${styles['pricelist-item-subtitle']}`}>{data.subtitle}</span> 
                            </Col>
                          </Row>
                          </div>
                              )})  
                    }
                </Container> 
                  <Container fluid="sm" className={`${styles['seperator']}`}>                 
                          <h1>Kurse</h1>                          
                  </Container>
                  <Container fluid="sm" className={`${styles['sub-seperator']}`}>                
                          <h1>Bei Bedarf können alle Kurse auch Online abgehalten werden</h1>                          
                  </Container>
                  <Container fluid="sm" >  
                    {
                      data.attributes.courses.map((data, i) => {                      
                        return (
                          <div className={`${styles['pricelist-item']}`} key={i}>   
                          <Row xs="1" sm="1" md="1">
                              <Col xs="8" sm="10" md="10" >
                                <span className={`${styles['pricelist-item-title']}`}>{data.title}</span> 
                              </Col>
                              <Col xs="4" sm="2" md="2">
                              <span className={`${styles['pricelist-item-title']}`}>{data.price} €</span> 
                            </Col>
                          </Row>
                          <Row xs="1" sm="1" md="1">
                            <Col md="12">
                              <span className={`${styles['pricelist-item-subtitle']}`}>{data.subtitle}</span> 
                            </Col>
                          </Row>
                          </div>
                              )})  
                    }
                </Container>      
            </section>
      <Footer />
      <BackToTopButton
      backgroundColor={variables.initial_backToTop_backgroundColor}
      borderColor='white'
      borderWidth='2px'
      width='40px'
      height='40px'
      iconColor='white'
      iconType={1}
      iconMarginTop='-10px'/>
      <CookieBanner
        title={t("cookie_banner_title")}
        subtitle={t("cookie_banner_subtitle")}
        description={t("cookie_banner_description")}
        text_save_selection={t("cookie_banner_text_save_selection")}
        text_accept_all={t("cookie_banner_text_accept_all")}
        text_checkbox_option1={t("cookie_banner_text_checkbox_option1")}
        text_checkbox_option2={t("cookie_banner_text_checkbox_option2")}
        text_checkbox_option3={t("cookie_banner_text_checkbox_option3")}
        gdpr_link={t("cookie_banner_gdpr_link")}
        gdpr_link_text={t("cookie_banner_gdpr_link_text")}
        imprint_link={t("cookie_banner_imprint_link")}
        imprint_link_text={t("cookie_banner_imprint_link_text")}
        display={showCookieBanner}
        handleAcceptAllClick={selectAll}
        handleSaveSelectionClick={saveSelection}
      ></CookieBanner>
    </>
  );
}
